import { render, staticRenderFns } from "./StudentInnerframeLayout.vue?vue&type=template&id=a9a762bc&scoped=true&lang=pug&"
import script from "./StudentInnerframeLayout.vue?vue&type=script&lang=ts&"
export * from "./StudentInnerframeLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInnerframeLayout.vue?vue&type=style&index=0&id=a9a762bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a762bc",
  null
  
)

export default component.exports